var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodtvTv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 432.18,
    height: 379.14,
    viewBox: "0 0 432.18 379.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M405.17,82.01h-149.51l58.94-58.94c5.27-5.27,5.27-13.81,0-19.08-5.26-5.27-13.8-5.28-19.08-.02,0,0-.02.02-.02.02l-78.02,78.02h-15.84L123.61,3.96c-5.26-5.27-13.8-5.28-19.08-.02,0,0-.02.02-.02.02-5.27,5.27-5.27,13.81,0,19.08l58.94,58.97H27.01c-14.89.06-26.95,12.12-27.01,27.01v243.11c.06,14.89,12.12,26.95,27.01,27.01h378.17c14.9-.04,26.97-12.11,27.01-27.01V109.02c-.04-14.9-12.11-26.97-27.01-27.01M297.13,325.12H54.02v-189.08h243.1v189.08ZM378.16,244.09h-27.01v-27.02h27.01v27.02ZM378.16,190.06h-27.01v-27.02h27.01v27.02Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodtvTv);
export default __webpack_public_path__ + "static/media/godtv-tv.0981c24613640b901f76e3ce1b4fd607.svg";
export { ForwardRef as ReactComponent };